import * as React from "react";

import Config from "../Config";
import InfoButton from "./InfoButton";

export default class HeroList extends React.Component
{
  render()
  {
    const { children, items, message } = this.props;

    const listItems = items.map((item, index) => (
      <li className="wrcWidget__list-item" key={index}>
        <i className={"ms-Icon ms-Icon--m ms-Icon--" + item.icon}></i>
        <span className="ms-font-sPlus ms-fontColor-neutralPrimary">{item.primaryText}</span>
      </li>
    ));
    return (
      <main className="wrcWidget wrcWidget--no-border">
        <h2 className="ms-font-l ms-fontWeight-semilight ms-fontColor-neutralPrimary ms-u-slideUpIn20 wrcWidget__label">
          {message}
          {/* <InfoButton target={Config.helpUrls.login} size={16} /> */}
        </h2>
        <ul className="wrcWidget__list">{listItems}</ul>
        {children}
      </main>
    );
  }
}
